import { ReportExport } from '@trukt/portal-utils/ReportExport';

export const EXPORTING_LOADING_STATES: ReportExport['status'][] = ['new', 'queued', 'started'];

// 30 seconds
export const SEARCH_REPORT_EXPORTS_REFETCH_INTERVAL = 1000 * 5;
